import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Heading,
  Text,
  VStack,
  useToast,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAdmin } from "../../context/AdminContext";
import { FaLock } from "react-icons/fa";

export default function AdminLogin() {
  const colors = {
    teal: "#1da179",
    tealLight: "#34c49b",
    orangeRed: "#f31f1c",
  };

  const { register, handleSubmit, formState: { errors } } = useForm();
  const toast = useToast();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const { login } = useAdmin();

  const onSubmit = async (data) => {
    try {
      const response = await axios.post("https://actpolymers-spring-26d90d713ec5.herokuapp.com/api/auth/login", data);
      const token = response.data.token;

      login(token);
      setTimeout(() => {
        navigate("/admin");
      }, 100);

      toast({
        title: isArabic ? "تم تسجيل الدخول بنجاح" : "Login successful",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: isArabic ? "بيانات الدخول غير صحيحة" : "Invalid credentials",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex
      minH="85vh"
      align="center"
      justify="center"
      bgGradient={`linear(to-b, white, ${colors.tealLight})`}
      px={4}
    >
      <Box
        maxW="md"
        w="full"
        bg="white"
        p={10}
        rounded="2xl"
        boxShadow="2xl"
        textAlign="center"
      >
        {/* ICON + TITLE */}
        <Flex justify="center" mb={4}>
          <Icon as={FaLock} boxSize={10} color={colors.teal} />
        </Flex>
        <Heading mb={6} color={colors.teal} fontSize="2xl" fontWeight="bold">
          {isArabic ? "تسجيل الدخول" : "Admin Login"}
        </Heading>

        {/* FORM */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <VStack spacing={5} align="stretch">
            {/* Username */}
            <FormControl isInvalid={errors.username}>
              <FormLabel>{isArabic ? "اسم المستخدم" : "Username"}</FormLabel>
              <Input
                {...register("username", { required: isArabic ? "مطلوب" : "Required" })}
                placeholder={isArabic ? "اسم المستخدم" : "Username"}
              />
              {errors.username && (
                <Text color="red.500" fontSize="sm">
                  {errors.username.message}
                </Text>
              )}
            </FormControl>

            {/* Password */}
            <FormControl isInvalid={errors.password}>
              <FormLabel>{isArabic ? "كلمة المرور" : "Password"}</FormLabel>
              <Input
                type="password"
                {...register("password", { required: isArabic ? "مطلوب" : "Required" })}
                placeholder="••••••••"
              />
              {errors.password && (
                <Text color="red.500" fontSize="sm">
                  {errors.password.message}
                </Text>
              )}
            </FormControl>

            {/* Submit */}
            <Button
              type="submit"
              bg={colors.teal}
              color="white"
              _hover={{ bg: colors.tealLight }}
              size="lg"
              w="full"
            >
              {isArabic ? "تسجيل الدخول" : "Login"}
            </Button>
          </VStack>
        </form>
      </Box>
    </Flex>
  );
}
